const getGrossMargin = (markupValue, markupType, unitRrp, packCost, packSize, taxRate) => {
  const sellingPrice = calculatePrice(markupValue, markupType, unitRrp, packCost, packSize)
  const exactCost = calcItemCost(packCost, packSize)

  const grossMargin = calculateGrossMargin(sellingPrice, taxRate, exactCost)

  return (grossMargin)
}

const calculateGrossMargin = (sellingPrice, vatRate, costPrice) => {
  sellingPrice = parseInt(sellingPrice)
  vatRate = parseFloat(vatRate)
  costPrice = parseFloat(costPrice)

  let grossMargin = null

  if (sellingPrice > 0 && costPrice > 0) {
    const vatContent = calcVATContent(sellingPrice, vatRate)

    grossMargin = _calcGM(sellingPrice, vatContent, costPrice)
  } else {
    return (null)
  }

  return (grossMargin)
}

const calcItemCost = (packCost, packSize) => {
  let itemCost = 0

  if (packCost > 0 && packSize > 0) {
    itemCost = packCost / packSize
  }

  return (itemCost)
}

const calcVATContent = (price, vatRate) => {
  price = parseInt(price)
  vatRate = parseFloat(vatRate)

  if (price === 0 || vatRate === 0) {
    return (0)
  } else {
    const vatMultiplier = 100 / (100 + vatRate)

    return (price - (price * vatMultiplier))
  }
}

const _calcGM = (totalSellingPrice, totalVatContent, totalCostPrice) => {
  const totalSellingPriceExVAT = totalSellingPrice - totalVatContent

  const grossMargin = ((totalSellingPriceExVAT - totalCostPrice) / totalSellingPriceExVAT) * 100

  return (grossMargin)
}

const calculatePrice = (calcValue, calcType, unitRrp, packCost, packSize) => {
  let newMarkupValue = 0
  const exactCost = calcItemCost(packCost, packSize)
  // if we don't do a Math.ceil below, it makes it impossible to set certain cost based prices due to rounding issues, however, this causes
  // any prices that we try and set as a %GM to be inaccurate compared to the actual gm due to rounding issues
  const itemCost = Math.ceil(exactCost)

  switch (calcType) {
    case 'PercentOverRRP':
      newMarkupValue = ((calcValue / 100) + 1) * unitRrp
      break
    case 'PercentOverCost':
      newMarkupValue = ((calcValue / 100) + 1) * exactCost
      break
    case 'PercentOfRRP':
      newMarkupValue = (calcValue / 100) * unitRrp
      break
    case 'PercentOfCost':
      newMarkupValue = (calcValue / 100) * itemCost
      break

      // case "%GM":
      //   if(itemCost > 0)
      //   {
      //       newMarkupValue = calcMarkupFromGrossMargin(calcValue, taxRate, exactCost)
      //   }
      //   else
      //   {
      //       newMarkupValue = markupValue // if no cost price has been set, we don't want to change the markup regardless of the GM that is set
      //   }
      //   break

    case 'PriceOverRRP':
      newMarkupValue = Number(calcValue) + Number(unitRrp)
      break
    case 'PriceOverCost':
      newMarkupValue = Number(calcValue) + Number(itemCost)
      break
    case 'Number':
      newMarkupValue = calcValue
      break
  }

  newMarkupValue = Math.max(0, Math.ceil(newMarkupValue)) // find_and_apply_override seems to use ceil function to round prices UP to next penny

  return (newMarkupValue)
}

const calculateMarkupValue = (unitRrp, packCost, packSize, calcType, markupValue) => {
  console.log(unitRrp, packCost, packSize, calcType, markupValue)

  const exactCost = calcItemCost(packCost, packSize)
  // if we don't do a Math.ceil below, it makes it impossible to set certain cost based prices due to rounding issues, however, this causes
  // any prices that we try and set as a %GM to be inaccurate compared to the actual gm due to rounding issues
  const itemCost = Math.ceil(exactCost)
  markupValue = Number(markupValue)

  let newCalcValue = 0

  switch (calcType) {
    case 'PercentOverRRP':
      if (unitRrp !== 0) {
        newCalcValue = ((markupValue / unitRrp) - 1) * 100
      } else {
        newCalcValue = 0
      }
      break
    case 'PercentOverCost':
      if (itemCost !== 0) {
        newCalcValue = ((markupValue / exactCost) - 1) * 100
      }
      break
    case 'PercentOfRRP':
      if (unitRrp !== 0) {
        newCalcValue = (markupValue / unitRrp) * 100
      }
      break
    case 'PercentOfCost':
      if (itemCost !== 0) {
        newCalcValue = (markupValue / itemCost) * 100
      }
      break

      // case 'PercentGM':
      //   newCalcValue = calcGrossMargin(markupValue, taxRate, exactCost)
      //   amountDP = 1
      //   break
    case 'PriceOverRRP':
      newCalcValue = markupValue - unitRrp
      break
    case 'PriceOverCost':
      newCalcValue = markupValue - itemCost
      break
    case 'Number':
      newCalcValue = markupValue
      break
  }

  console.log('new calc value:', newCalcValue)

  return (newCalcValue)
}

// lifted from PriceCalculations.js - just lightly modified for style
const formatNumber = (expr, places) => {
  const multiplier = Math.pow(10, places)
  // var fixpt = Math.round(eval(expr) * multiplier)
  const fixpt = Math.round(expr * multiplier)
  const strNum = '' + fixpt

  let intPart = strNum.substr(0, strNum.length - places)

  if (intPart.length === 0) {
    intPart = 0
  }

  const frctnlPart = strNum.substr(strNum.length - places)
  let dotPart = '.'

  if (places === 0) {
    dotPart = ''
  }

  return ('' + intPart + dotPart + frctnlPart)
}

module.exports = {
  formatNumber,
  calculateMarkupValue,
  calculatePrice,
  getGrossMargin,
  calcItemCost
}
